import React from 'react';

const OAuthButton = ({ provider, onClick, className = "" }) => {
  const providerConfig = {
    google: {
      text: "Sign in with Google",
      bgColor: "bg-white hover:bg-gray-50",
      textColor: "text-gray-700",
      borderColor: "border-gray-300",
      icon: "/assets/oauth/google-logo.png",
      fallbackSvg: "/assets/oauth/google-signin.svg"
    },
    facebook: {
      text: "Continue with Facebook", 
      bgColor: "bg-[#1877f2] hover:bg-[#166fe5]",
      textColor: "text-white",
      borderColor: "border-[#1877f2]",
      icon: null,
      fallbackSvg: "/assets/oauth/facebook-signin.svg"
    },
    apple: {
      text: "Sign in with Apple",
      bgColor: "bg-black hover:bg-gray-900", 
      textColor: "text-white",
      borderColor: "border-black",
      icon: null,
      fallbackSvg: "/assets/oauth/apple-signin.svg"
    },
    microsoft: {
      text: "Sign in with Microsoft",
      bgColor: "bg-[#0078d4] hover:bg-[#106ebe]",
      textColor: "text-white",
      borderColor: "border-[#0078d4]",
      icon: "/assets/oauth/microsoft-logo.png",
      fallbackSvg: "/assets/oauth/microsoft-signin.svg"
    }
  };

  const config = providerConfig[provider];
  if (!config) return null;

  // Use consistent button styling for all providers
  return (
    <button
      onClick={onClick}
      className={`
        w-full flex items-center justify-center gap-3 px-4 py-3 rounded-lg border
        ${config.bgColor} ${config.textColor} ${config.borderColor}
        font-medium transition-colors duration-200 shadow-sm
        ${className}
      `}
    >
      {config.icon && (
        <img 
          src={config.icon} 
          alt={`${provider} logo`}
          className="w-5 h-5"
        />
      )}
      <span>{config.text}</span>
    </button>
  );


};

export default OAuthButton;